const base = {
    baseUrl: "https://www.incmoon.com",
    // baseUrl: "/proxy_api",
    // baseUrl: "/local_api",

    // 手机
    getMobileCaptcha: "/tomato/account/mobile/captcha",
    getLoginByMobile: "/tomato/account/login/mobile",
    // QQ登录
    tencentGetInfo: "/tomatoPlan_web/getTencentInfo",
    getLoginByTencent: "/tomato/account/login/QQ",
    // 微信登录
    weChatGetInfo: "/tomatoPlan_web/getWeChatInfo",
    getLoginByWeChat: "/tomato/account/login/weChat",
    // Apple 登录
    getAppleInfo: "/tomatoPlan_web/getAppleInfo",
    getLoginByApple: "/tomato/account/login/Apple",
    // 获取用户信息
    getUserInfo: "/tomato/user/info",

    // 上传图片——oss
    ossPutImage: "/tomatoPlan_web/ossPutImage/",
    // 删除图片——oss
    ossDeleteImage: "/tomatoPlan_web/ossDeleteImage/",

    syncList: "/tomato/syncData/listInfo",
}

export default base;